import { useAppSessions } from "@/api";
import { AnalyticsView } from "./AnalyticsView";

const GlobalAnalyticsPage = () => {
  return <AnalyticsView query={useAppSessions} />;
};

export default GlobalAnalyticsPage;
